import { render, staticRenderFns } from "./PaymentSuccessPage.vue?vue&type=template&id=f5c655ee&scoped=true"
import script from "./PaymentSuccessPage.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessPage.vue?vue&type=script&lang=js"
import style0 from "./PaymentSuccessPage.vue?vue&type=style&index=0&id=f5c655ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c655ee",
  null
  
)

export default component.exports